import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, useStyleConfig} from '@chakra-ui/react'
import {Controller, Navigation, Pagination, Keyboard} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/react'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {remCalc} from '../../../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'
import ProductBox from './partials/product-box'
import {useProducts} from '@salesforce/commerce-sdk-react'

export const ProductMoodboard = ({productMoodboardGroup = []}) => {
    const swiperStyles = useStyleConfig('Swiper')
    const styles = useStyleConfig('ProductMoodboard')
    const {currency} = useCurrency()

    const [contentSwiper, setContentSwiper] = useState(null)

    var productIds = []
    productMoodboardGroup.forEach((group) =>
        group.products?.data.forEach((p) => productIds.push(p.id)),
    )

    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: productIds.join(','),
                expand: ['availability', 'images'],
                currency,
            },
            headers: {
                'x-debug': 'prod-moodboard-index',
            },
        },
        {
            enabled: productIds?.length > 0,
        },
    )

    return (
        productMoodboardGroup?.length > 0 && (
            <Box
                data-testid="product-moodboard"
                data-cs-label="editorial-product_moodboard"
                {...styles.container}
            >
                <Box __css={{...swiperStyles, ...styles.tabs}} role="tablist">
                    <Swiper
                        key={'product-moodboard-mobile-pagination'}
                        modules={[Controller]}
                        slidesPerView={3}
                        enabled={false}
                        centeredSlides={true}
                        onSwiper={setContentSwiper}
                    >
                        {productMoodboardGroup.map((tile, tIndex) => (
                            <SwiperSlide
                                key={`navigation-slider-tile-${tIndex}`}
                                modules={[Controller]}
                            >
                                {({isActive}) => {
                                    const id = `product-moodboard-tab-mobile-${tIndex}`
                                    const panelId = `product-moodboard-panel-${tIndex}`
                                    return (
                                        <button
                                            role="tab"
                                            id={id}
                                            aria-controls={panelId}
                                            aria-selected={isActive}
                                            tabIndex={isActive ? 0 : -1}
                                            className="product-moodboard-mobile-pagination-btn"
                                        >
                                            <Text
                                                textStyle={'body-small'}
                                                fontWeight={'bold'}
                                                color={'text.default'}
                                                py={remCalc(24)}
                                                textTransform={isActive ? 'uppercase' : 'none'}
                                                textDecoration={isActive ? 'underline' : 'none'}
                                                textUnderlineOffset={remCalc(4)}
                                            >
                                                {tile.label || ''}
                                            </Text>
                                        </button>
                                    )
                                }}
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Box>
                <Box __css={{...swiperStyles, ...styles.content}}>
                    <Flex className="product-moodboard-pagination" {...styles.pagination} />
                    <Swiper
                        key={'product-moodboard-swiper'}
                        modules={[Controller, Navigation, Pagination, Keyboard]}
                        controller={{control: contentSwiper}}
                        pagination={{
                            clickable: true,
                            el: '.product-moodboard-pagination',
                            renderBullet: (index, className) => {
                                const id = `product-moodboard-tab-${index}`
                                const panelId = `product-moodboard-panel-${index}`
                                const isActive = className.includes(
                                    'swiper-pagination-bullet-active',
                                )
                                return `<button role="tab" id="${id}" aria-controls="${panelId}" aria-selected="${isActive}" tabindex="${
                                    isActive ? '0' : '-1'
                                }" class="${className}">${
                                    productMoodboardGroup[index].label
                                }</button>`
                            },
                        }}
                        className={`product-moodboard-swiper`}
                    >
                        {productMoodboardGroup.map((tile, tIndex) => {
                            const hasTwoTiles = tile.products?.data?.length == 2
                            const hasThreeTiles = tile.products?.data?.length == 3
                            const hasFourTiles = tile.products?.data?.length == 4
                            const hasFiveTiles = tile.products?.data?.length == 5
                            const tabId = `product-moodboard-tab-mobile-${tIndex}`
                            return (
                                <SwiperSlide
                                    key={`product-moodboard-tile-${tIndex}`}
                                    role="tabpanel"
                                    id={`product-moodboard-panel-${tIndex}`}
                                    aria-labelledby={tabId}
                                >
                                    <Flex {...styles.boardcontainer}>
                                        <Flex {...styles.boardfirsthalf}>
                                            <ProductBox
                                                product={{
                                                    ...productsData?.data?.find(
                                                        (product) =>
                                                            product.id == tile.products?.data[0].id,
                                                    ),
                                                }}
                                                styleVariant={'default'}
                                            />
                                        </Flex>
                                        <Flex {...styles.boardsecondhalf}>
                                            {hasTwoTiles && (
                                                <ProductBox
                                                    product={{
                                                        ...productsData?.data?.find(
                                                            (product) =>
                                                                product.id ==
                                                                tile.products?.data[1].id,
                                                        ),
                                                    }}
                                                    styleVariant={'default'}
                                                />
                                            )}
                                            {hasThreeTiles && (
                                                <>
                                                    <ProductBox
                                                        product={{
                                                            ...productsData?.data?.find(
                                                                (product) =>
                                                                    product.id ==
                                                                    tile.products?.data[1].id,
                                                            ),
                                                        }}
                                                        styleVariant={'mediumTile'}
                                                    />
                                                    <ProductBox
                                                        product={{
                                                            ...productsData?.data?.find(
                                                                (product) =>
                                                                    product.id ==
                                                                    tile.products?.data[2].id,
                                                            ),
                                                        }}
                                                        styleVariant={'mediumTile'}
                                                    />
                                                </>
                                            )}
                                            {hasFourTiles && (
                                                <>
                                                    <ProductBox
                                                        product={{
                                                            ...productsData?.data?.find(
                                                                (product) =>
                                                                    product.id ==
                                                                    tile.products?.data[1].id,
                                                            ),
                                                        }}
                                                        styleVariant={'mediumTile'}
                                                    />
                                                    <Flex {...styles.boardtwoboxcontainer}>
                                                        <ProductBox
                                                            product={{
                                                                ...productsData?.data?.find(
                                                                    (product) =>
                                                                        product.id ==
                                                                        tile.products?.data[2].id,
                                                                ),
                                                            }}
                                                            styleVariant={'smallTile'}
                                                        />
                                                        <ProductBox
                                                            product={{
                                                                ...productsData?.data?.find(
                                                                    (product) =>
                                                                        product.id ==
                                                                        tile.products?.data[3].id,
                                                                ),
                                                            }}
                                                            styleVariant={'smallTile'}
                                                        />
                                                    </Flex>
                                                </>
                                            )}
                                            {hasFiveTiles && (
                                                <>
                                                    <Flex {...styles.boardtwoboxcontainer}>
                                                        <ProductBox
                                                            product={{
                                                                ...productsData?.data?.find(
                                                                    (product) =>
                                                                        product.id ==
                                                                        tile.products?.data[1].id,
                                                                ),
                                                            }}
                                                            styleVariant={'smallTile'}
                                                        />
                                                        <ProductBox
                                                            product={{
                                                                ...productsData?.data?.find(
                                                                    (product) =>
                                                                        product.id ==
                                                                        tile.products?.data[2].id,
                                                                ),
                                                            }}
                                                            styleVariant={'smallTile'}
                                                        />
                                                    </Flex>
                                                    <Flex {...styles.boardtwoboxcontainer}>
                                                        <ProductBox
                                                            product={{
                                                                ...productsData?.data?.find(
                                                                    (product) =>
                                                                        product.id ==
                                                                        tile.products?.data[3].id,
                                                                ),
                                                            }}
                                                            styleVariant={'smallTile'}
                                                        />
                                                        <ProductBox
                                                            product={{
                                                                ...productsData?.data?.find(
                                                                    (product) =>
                                                                        product.id ==
                                                                        tile.products?.data[4].id,
                                                                ),
                                                            }}
                                                            styleVariant={'smallTile'}
                                                        />
                                                    </Flex>
                                                </>
                                            )}
                                        </Flex>
                                    </Flex>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </Box>
            </Box>
        )
    )
}

ProductMoodboard.propTypes = {
    productMoodboardGroup: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            products: PropTypes.shape({
                data: PropTypes.arrayOf(
                    PropTypes.shape({
                        id: PropTypes.string,
                        name: PropTypes.string,
                        image: PropTypes.shape({
                            alt: PropTypes.string,
                            link: PropTypes.string,
                            title: PropTypes.string,
                        }),
                        currency: PropTypes.string,
                        price: PropTypes.number,
                    }),
                ),
            }),
        }),
    ),
}
